import React, { useEffect, useMemo, useState } from "react";
import CountUp from "react-countup";
import { Card, CardBody } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import CardWidgetSkeleton from "Components/Common/CardWidgetSkeleton";
import { getGovtRequests } from "common/services/govt-requests.service";
import { getYearDateRange } from "common/lib/dateUtils";
import useQueryState from "Components/Hooks/UseQueryState";
import { useProfile } from "Components/Hooks/UserHooks";

const GovernmentRequests = () => {
  const { userProfile } = useProfile();
  const [loading, setLoading] = useState(false);
  const [NTPRequests, setNTPRequests] = useState(0);
  const [totalRequests, setTotalRequests] = useState(0);

  const [selectedYear] = useQueryState(
    "year",
    new Date().getFullYear().toString()
  );
  const { firstDay, lastDay } = getYearDateRange(Number(selectedYear));

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response: any = await getGovtRequests({
          filters: {
            agency: userProfile?.agency?.id,
            $or: [
              {
                dateOfRequest: {
                  $between: [firstDay, lastDay],
                },
              },
            ],
          },
        });
        setTotalRequests(response?.meta?.pagination?.total || 0);
      } catch (error) {
        console.warn("Error fetching aligning support", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [firstDay, lastDay, userProfile?.agency?.id]);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        // Simulate fetching data
        const response: any = await getGovtRequests({
          filters: {
            agency: userProfile?.agency?.id,
            $or: [
              {
                dateOfRequest: {
                  $between: [firstDay, lastDay],
                },
              },
            ],
            typeOfRequest: {
              code: "NTP",
            },
          },
        });
        setNTPRequests(response?.meta?.pagination?.total || 0);
      } catch (error) {
        console.warn("Error fetching aligning support", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [firstDay, lastDay, userProfile?.agency?.id]);

  const percentageValue = useMemo(() => {
    if (totalRequests === 0) return 0;
    return (NTPRequests / totalRequests) * 100;
  }, [NTPRequests, totalRequests]);

  if (loading) {
    return <CardWidgetSkeleton />;
  }

  return (
    <Card className="card-animate card-bottom-primary">
      <CardBody>
        <div className="d-flex justify-content-between">
          <div>
            <p className="fw-medium text-muted mb-0">Government Requests</p>
            <h2 className="mt-4 ff-secondary cfs-22 fw-semibold">
              <span className="counter-value" data-target="33.48">
                <CountUp
                  start={0}
                  end={totalRequests}
                  decimals={0}
                  duration={4}
                />
              </span>
            </h2>
            <p className="mb-0 text-muted text-truncate">
              <span className="badge bg-light text-success mb-0">
                {/* <i className="ri-arrow-up-line align-middle"></i>  */}
                {percentageValue.toFixed(2)} %
              </span>{" "}
              NTP
            </p>
          </div>
          <div>
            <div className="avatar-sm flex-shrink-0">
              <span className="avatar-title bg-info-subtle rounded-circle fs-2">
                <FeatherIcon icon="external-link" className="text-success" />
              </span>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default GovernmentRequests;
